import { render } from "./GameBoard.vue?vue&type=template&id=d38c6572"
import script from "./GameBoard.vue?vue&type=script&lang=js"
export * from "./GameBoard.vue?vue&type=script&lang=js"

import "./GameBoard.vue?vue&type=style&index=0&id=d38c6572&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__